import { FC, ReactElement } from 'react';
import { CatStatusIndicator } from '@blocks-react/components/StatusIndicator';
import styles from '../NotificationDrawer.module.scss';

interface NotificationContentProps {
  purchaseOrderNumber: string;
  PENDING_QUOTE7: string;
  isRead: boolean;
  children: ReactElement;
}

export const NotificationContentWrapper: FC<NotificationContentProps> = ({
  purchaseOrderNumber,
  PENDING_QUOTE7,
  isRead,
  children,
}) => {
  return (
    <>
      {purchaseOrderNumber ? (
        <div data-testid="purchase-Order-number">
          <p className={` u-fs--12 ${styles['notification_poNumber']}`}>
            {`${PENDING_QUOTE7}: ${purchaseOrderNumber}`}
          </p>
        </div>
      ) : null}
      {!!isRead === false && (
        <CatStatusIndicator
          type="bare"
          className={`mr-2 position-absolute ${styles['left-4']}`}
          data-testid="readicon"
        />
      )}
      {children}
    </>
  );
};
